// extracted by mini-css-extract-plugin
export default {"card":"U6-z"};